function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { usePrevious } from '@deephaven/react-hooks';
import IrisGridBottomBar from "./IrisGridBottomBar.js";
import "./PendingDataBottomBar.css";
import { jsx as _jsx } from "react/jsx-runtime";
var HIDE_TIMEOUT = 3000;
export function ToastBottomBar(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    onEntering = _ref.onEntering,
    onEntered = _ref.onEntered,
    onExiting = _ref.onExiting,
    onExited = _ref.onExited;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShown = _useState2[0],
    setIsShown = _useState2[1];
  var timeout = useRef();
  var prevChildren = usePrevious(children);
  var startTimer = useCallback(() => {
    setIsShown(true);
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      setIsShown(false);
    }, HIDE_TIMEOUT);
  }, [setIsShown, timeout]);
  useEffect(() => {
    if (prevChildren !== children && children != null) {
      startTimer();
    }
  }, [children, prevChildren, setIsShown, startTimer]);
  useEffect(() => () => timeout.current ? clearTimeout(timeout.current) : undefined, []);
  return /*#__PURE__*/_jsx(IrisGridBottomBar, {
    className: "toast-bottom-bar",
    isShown: isShown,
    onEntering: onEntering,
    onEntered: onEntered,
    onExiting: onExiting,
    onExited: onExited,
    children: children
  });
}
export default ToastBottomBar;
//# sourceMappingURL=ToastBottomBar.js.map